var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 22,
    viewBox: "0 0 13 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75736 1.75736C5.88258 0.632141 7.4087 0 9 0H12C12.5523 0 13 0.447715 13 1V5C13 5.55228 12.5523 6 12 6H9V8H12C12.3079 8 12.5987 8.14187 12.7882 8.38459C12.9777 8.6273 13.0448 8.94379 12.9701 9.24254L11.9701 13.2425C11.8589 13.6877 11.4589 14 11 14H9V21C9 21.5523 8.55228 22 8 22H4C3.44772 22 3 21.5523 3 21V14H1C0.447715 14 0 13.5523 0 13V9C0 8.44772 0.447715 8 1 8H3V6C3 4.4087 3.63214 2.88258 4.75736 1.75736ZM9 2C7.93913 2 6.92172 2.42143 6.17157 3.17157C5.42143 3.92172 5 4.93913 5 6V9C5 9.55229 4.55228 10 4 10H2V12H4C4.55228 12 5 12.4477 5 13V20H7V13C7 12.4477 7.44772 12 8 12H10.2192L10.7192 10H8C7.44772 10 7 9.55229 7 9V6C7 5.46957 7.21071 4.96086 7.58579 4.58579C7.96086 4.21071 8.46957 4 9 4H11V2H9Z",
    fill: "#12B7A3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.db455aca5a683683789b57d7bfcae787.svg";
export { ForwardRef as ReactComponent };